import { CitedChunk, SectionSource } from 'models/AIArtifact';

/**
 * Build a `chunkId -> page` lookup from a summary or comparison's top-level
 * `chunks` array. Used to resolve citation hover-preview pages.
 */
export function buildChunkPageMap(chunks: CitedChunk[] | undefined): Record<string, number> {
  const map: Record<string, number> = {};
  for (const chunk of chunks ?? []) {
    map[chunk.id] = chunk.page;
  }
  return map;
}

/**
 * For one section, return `attachmentId -> page` (the page of the chronologically
 * first cited chunk for that attachment in that section). Sections without
 * `sources` (legacy artifacts) yield an empty map and the badge falls back to
 * the filename tooltip.
 */
export function buildPageByAttachmentId(
  sources: SectionSource[] | undefined,
  chunkPageById: Record<string, number>
): Record<string, number> {
  return Object.fromEntries(
    (sources ?? []).flatMap((source) => {
      const firstChunkId = source.chunkIds?.[0];
      const page = firstChunkId ? chunkPageById[firstChunkId] : undefined;
      return typeof page === 'number' ? [[source.attachmentId, page]] : [];
    })
  );
}
